"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.OuterRoot = void 0;
var _mui = require("@ori-ui/mui");
var _presentationUtils = require("@ori/presentation-utils");
const OuterRoot = exports.OuterRoot = (0, _mui.styled)('div', {
  shouldForwardProp: (0, _presentationUtils.shouldForwardProp)()
})(({
  theme,
  renderOnMyPages
}) => ({
  width: '100vw',
  marginLeft: 'calc(-50vw + 50%)',
  ...(renderOnMyPages && {
    maxWidth: '100%',
    marginLeft: 0,
    [theme.breakpoints.up('sm')]: {
      marginLeft: theme.spacing(-3),
      maxWidth: `calc(100% + ${theme.spacing(6)})`
    }
  })
}));
